import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import config from '../../config';
import './Auth.css';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isValid, setIsValid] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Validate token when component mounts
    const validateToken = async () => {
      try {
        await axios.get(`${config.API_BASE_URL}/auth/reset-password/${token}`);
        setIsValid(true);
      } catch (error) {
        setError('This password reset link is invalid or has expired.');
      }
    };
    validateToken();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      await axios.post(`${config.API_BASE_URL}/auth/reset-password/${token}`, {
        password
      });
      setMessage('Password has been reset successfully. Redirecting to login...');
      setTimeout(() => navigate('/'), 3000);
    } catch (error) {
      setError(error.response?.data?.error || 'Error resetting password');
    }
  };

  if (!isValid) {
    return (
      <div className="auth-form">
        <div className="auth-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="auth-form">
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}
        <button type="submit">Reset Password</button>
      </form>
    </div>
  );
}

export default ResetPassword; 